import * as $ from 'jquery';
import { apiBaseUrlUser } from '../../../constants/url.constant';
import { DefaultService } from '../../common/services/DefaultService';

export class WebsiteService extends DefaultService {
    private baseUrl = `${apiBaseUrlUser}/website`;

    public RouteGetOpenList = () => `${this.baseUrl}/getOpenList`;
    public getOpenList(): JQueryPromise<any> {
        return $.ajax(this.RouteGetOpenList(), {
            type: 'get',
            contentType: 'application/json'
        });
    }

    public RouteGetTopList = (count: number) => `${this.baseUrl}/getTopList?count=${count}`;
    public getGetTopList(count: number): JQueryPromise<any> {
        return $.ajax(this.RouteGetTopList(count), {
            type: 'get',
            contentType: 'application/json'
        });
    }
}